// extracted by mini-css-extract-plugin
export default {"clientReference":"ClientReference_clientReference__mk-ZO","mobile":"ClientReference_mobile__6Lrtn","title":"ClientReference_title__C3Byq","logos":"ClientReference_logos__XiIcu"};